import React, { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper,
    TableHead, TablePagination, TextField, Dialog,
    DialogActions, DialogContent, Box, DialogContentText, DialogTitle, Button, Typography, Link
} from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import AddGasto from './AddGasto';
import { useAccesos } from '../contexts/AccesosContext';



function GestionGasto({ idCampania = null, gastos: gastosProp = null, onUpdate}) {
    // Estado con tareas simuladas
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [gastos, setGastos] = useState([]);
    const [editGasto, setEditGasto] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [gastoToDelete, setGastoToDelete] = useState(null);
    const { user } = useUser();   
    const { tienePermiso } = useAccesos();


    const fetchGastos = async () => {
        try {
            const response = await fetch(`${server}/CrmGastoCampaniums/poridCampania/${idCampania}`);
            const data = await response.json();
            setGastos(data.$values);
                } catch (error) {
                    console.error('Error al cargar los gastos', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar los gastos: ' + error,
                    });
                }
            };

        useEffect(() => {
             const fetchGastos = async () => {
                try {
                let response;
                if (idCampania) {
                    response = await fetch(`${server}/CrmGastoCampaniums/poridCampania/${idCampania}`);
                } else {
                    response = await fetch(`${server}/CrmGastoCampaniums`);
                }

                const data = await response.json();
                setGastos(data.$values || []);
                } catch (error) {
                console.error('Error al cargar los gastos', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los gastos: ' + error,
                });
                }
            };
                fetchGastos();
            }, [idCampania, gastosProp]);

            if (!idCampania) {
                    return (
                    <Typography variant="body1" color="textSecondary">
                        Selecciona una campaña para ver sus gastos.
                    </Typography>
                );
            }
        
            const handleNewGasto = () => {
                if (idCampania) {
                    fetch(`${server}/CrmGastoCampaniums/poridCampania/${idCampania}`)
                    .then(res => res.json())
                    .then(data => {
                         setGastos(data.$values || []);
                    if (onUpdate) onUpdate();
                })
                    .catch(console.error);
                }else {
                    fetch( `${server}/CrmGastoCampaniums`)
                    .then(res => res.json())
                    .then(data => { setGastos(data.$values || []);
                        if (onUpdate) onUpdate();
                    })
                    .catch(console.error);
                }
                setEditGasto(null);
            };

        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (gasto) => {
                setGastoToDelete(gasto);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setGastoToDelete(null);
            };
        
            const handleDeleteGasto= async () => {
                if (gastoToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmGastoCampaniums/${gastoToDelete.idGasto}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchGastos(); // Recargar la lista de campanias
                            if (onUpdate) onUpdate(); 
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Gasto eliminado con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el gasto:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el gasto: ' + error,
                        });            }
                }
            };
        
            const filteredGasto = gastos.filter(gasto => gasto.tituloGasto?.toLowerCase().includes(searchQuery.toLowerCase()));
    
        const handleCancelarEdicion = () => {
            setEditGasto(null);
        }


    return (
        <>
            <div className="x_content">
                <br />
                
                <AddGasto handleNewGasto={handleNewGasto} editGasto={editGasto} idCampania={idCampania} cancelarEdicion={handleCancelarEdicion}/>
                <div className="ln_solid" />
                <h2>Gastos Existentes</h2>

                <TextField
                    fullWidth
                    variant="outlined"
                    label="Buscar Gasto"
                    placeholder="Buscar..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{ marginBottom: '20px' }}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="right">Acciones</TableCell>
                                <TableCell>Título</TableCell>
                                <TableCell>Descripción</TableCell>
                                <TableCell>Tipo Gasto</TableCell>
                                <TableCell>Monto</TableCell>
                                <TableCell>Fecha</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {filteredGasto.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((gasto) => (
                            <TableRow key={gasto.idGasto}>
                            <TableCell align="right">
                                <Button onClick={() => setEditGasto(gasto)} color="primary" disabled={!tienePermiso('Editar Gasto CRM')}>
                                    Editar
                                </Button>
                                <Button onClick={() => handleOpenDialog(gasto)} color="secondary" disabled={!tienePermiso('Eliminar Gasto CRM')}>
                                    Eliminar
                                </Button>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {gasto.tituloGasto}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {gasto.decripcionGasto}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {gasto.tipoGasto}
                            </TableCell>
                             <TableCell component="th" scope="row">
                                {gasto.monto}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {gasto.fecha}
                            </TableCell>
                            </TableRow>
                           ))}        
                        </TableBody>
                    </Table>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={gastos.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
                    <Dialog open={openDialog}
                                                onClose={handleCloseDialog}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description">
                                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-description">
                                                        ¿Estás seguro de que quieres eliminar este gasto?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                                    <Button onClick={handleDeleteGasto} color="primary" autoFocus>Eliminar</Button>
                                                </DialogActions>
                                            </Dialog>
            </div>
        </>
    );
}

export default GestionGasto;